import awsEvent from './awsEvent';
export default awsEvent('s3');